import Component from "../component.abstract"
import CategoryService  from "@services/category-service";
import { initialiseComponents } from '../../core'
import {hw} from "../helpers/paths"

interface CategoryProps {
    api: string;
    serpUrl: string;
}


// Mock to adapt
///////////////////////////////////////
const dataLayer = window.dataLayer || [];
///////////////////////////////////////

/**
 * Category Component
 */
export default class Category extends Component {
    private menu: any
    private open: any
    private research: any
    private menumobile: any
    private return: any
    private modal: any
    private service: CategoryService

    constructor (
        private props: CategoryProps,
        element: HTMLElement
    ) {  
        super(props, element)
        this.service = new CategoryService(props.api);
        this.research = props.serpUrl;
    }

    mounted():void {
        this.menu = this.element.querySelectorAll('ul')[0];
        this.open = false;
        this.menumobile = this.element.querySelectorAll('.catmobile')[0];
        this.return = this.element.querySelectorAll('.return')[0];

        this.init();
    }

    init():void {     
        this.element.addEventListener('click', (event) => {
            if(this.open == false) {
                if(this.menu.querySelectorAll('li').length == 0) {
                    this.call();
                    this.buildmodal();
                }
                this.menu.classList.remove('hide');
                this.open = true;
                if(window.innerWidth < 767) {
                    this.menumobile.classList.add('open')
                } else {
                    this.modal.classList.add('show')
                }

                dataLayer.push({ 'event': 'EventGeneric', 'EventCat': 'Menu', 'EventAction': 'Load', 'EventLibelle': 'Menu Categorie - Niveau 1' });
            } else {
                if((<HTMLElement>event.target).className == "catlink") {
                    this.menu.classList.add('hide');

                    this.open = false;
                    if(window.innerWidth < 767) {
                        this.menumobile.classList.remove('open')
                    } else {
                        this.modal.classList.remove('show')
                    }
                    dataLayer.push({ 'event': 'EventGeneric', 'EventCat': 'Menu', 'EventAction': 'Unload', 'EventLibelle': 'Menu Categorie - Niveau 1' });
                }

            }
        })
    }

    call():void {
        this.service.get(this.work.bind(this))
    }

    work(data:any):void {
        const labelregex = new RegExp("/", "g")
        for (let i = 0; i < data.length; i++) {
            let shorturi = data[i].ShortUri;
            shorturi = shorturi.toLowerCase();
            // cas particulier svg qui avait déjà le nom "commerce"
            if(shorturi == "commerce") {
                shorturi = "commerce_";
            }
            const svgns = "http://www.w3.org/2000/svg";
            const divicon =  document.createElementNS(svgns, "svg");
            divicon.setAttribute("data-load-url", hw.getBaseRessourcesUrl() + "/img/svg/" + shorturi + ".svg")
              
            if(data[i].Functions.length > 1) {
                const lo = document.createElement('li');
                lo.classList.add("super");
                let labelS = data[i].Label;
                labelS = labelS.replace(labelregex, " • ");
                const spanS = document.createElement('span');
                spanS.innerText = labelS;

                lo.appendChild(divicon);
                lo.appendChild(spanS);

                const $ul = document.createElement('ul');
                $ul.classList.add('hide')
                const liback =  document.createElement('li');
                liback.classList.add('headset');
                const libackspan = document.createElement('span');
                libackspan.innerText = "Toutes les catégories";
                const svgUp = document.createElementNS(svgns, "svg");
                svgUp.setAttribute("data-load-url",hw.getBaseRessourcesUrl() + "/img/svg/up-nocolor.svg")
              
                liback.appendChild(svgUp);
                liback.appendChild(libackspan)
                $ul.appendChild(liback);

                const lititle = document.createElement('li');
                lititle.classList.add('lititle');

                const lititleA = document.createElement('a');

                const lititleSpan = document.createElement('span');
                let labeltitle = data[i].Label;
                const parentUri = data[i].ShortUri;
                lo.setAttribute("data-uri", parentUri.toLowerCase())
                liback.setAttribute("data-uri", parentUri.toLowerCase())

                labeltitle = labeltitle.replace(labelregex, " • ")
                lititleSpan.innerText = labeltitle;

                const svgup2 = document.createElement("span");
                svgup2.setAttribute("data-load-url",hw.getBaseRessourcesUrl() + "/img/svg/up-nocolor.svg");
                lititleA.appendChild(svgup2);
                lititleA.appendChild(lititleSpan);
                lititle.append(lititleA);
                $ul.appendChild(lititle);
                const $hrefT = [];
                for(let y=0; y<data[i].Functions.length; y++) {
                    const lisub = document.createElement('li');
                    const link = document.createElement('a');
                    let label = data[i].Functions[y].Label;

                    const spanlink = document.createElement('span')
                    label = label.replace(labelregex, " • ")
                    spanlink.innerText = label;

                    let $href = data[i].Functions[y].ShortUri;
                    const $uri = $href;
                    $href = this.research + "&f=" + $href;
                    link.setAttribute('href', $href);
                    const onclickAction = "dataLayer.push({ 'event': 'EventGeneric', 'EventCat': 'Menu', 'EventAction': 'Clic', 'EventLibelle': 'Menu Categorie - Niveau 2 - "+parentUri.toLowerCase()+" - Niveau 2/ "+$uri.toLowerCase()+"'});"
                    link.setAttribute('onclick', onclickAction)

                    $hrefT.push( "&f=" +data[i].Functions[y].ShortUri);

                    const svgUp3 = document.createElement("span");
                    svgUp3.setAttribute("data-load-url",hw.getBaseRessourcesUrl() + "/img/svg/up-nocolor.svg")
                    link.appendChild(svgUp3);
                    link.appendChild(spanlink)

                    lisub.appendChild(link);
                    $ul.appendChild(lisub);
                }
                const hrefCompile = $hrefT.toString();
                const virgulregx = new RegExp(",", "g");
                const $hrefTitle = this.research + hrefCompile.replace(virgulregx,'');
                lititleA.setAttribute('href', $hrefTitle);
                const onclickActionT = "dataLayer.push({ 'event': 'EventGeneric', 'EventCat': 'Menu', 'EventAction': 'Clic', 'EventLibelle': 'Menu Categorie - Niveau 2 - "+ parentUri.toLowerCase()+" - Niveau 1'});"
                lititleA.setAttribute('onclick', onclickActionT)

                this.menu.appendChild(lo);
                lo.after($ul);
                lo.addEventListener('click', (event) => {
                    event.preventDefault();
                    event.stopImmediatePropagation();
                    const target:any = event.currentTarget;
                    this.openSub(target.nextElementSibling, target);
                })
                liback.addEventListener('click', (event) => {
                    event.preventDefault();
                    event.stopImmediatePropagation();
                    const target:any = event.currentTarget;
                    this.closeSub(target.parentElement, target);
                })
            } else {
                const li = document.createElement('li');
                li.classList.add("super");
                const a = document.createElement('a');
                let labelSu = data[i].Label;
                labelSu = labelSu.replace(labelregex, " • ")

                const spanSu = document.createElement('span');
                spanSu.innerText = labelSu;

                a.appendChild(divicon);
                a.appendChild(spanSu);

                let $href = data[i].Functions[0].ShortUri;
                const parenturiAlone = $href;
                $href = this.research + "&f=" + $href;
                a.setAttribute('href', $href);

                const onclickActionTT = "dataLayer.push({ 'event': 'EventGeneric', 'EventCat': 'Menu', 'EventAction': 'Clic', 'EventLibelle': 'Menu Categorie- Niveau 1 - "+parenturiAlone.toLowerCase()+"'});"
                a.setAttribute('onclick', onclickActionTT)

                li.appendChild(a);
                this.menu.appendChild(li);
            }

        }
        const closer = document.createElement("span");
        closer.classList.add('closer');
        const close = document.createElement('span');
        close.setAttribute("data-load-url",hw.getBaseRessourcesUrl() + "/img/svg/close0.svg")
        closer.appendChild(close);
        this.menu.appendChild(closer);

        initialiseComponents();

        this.return.addEventListener('click', (event: MouseEvent) => {
            this.close(event);
        })

        closer.addEventListener('click', (event: MouseEvent) => {
            this.close(event);
        })
    }

    openSub (elt: any, uri: any) {
        const uriString = uri.getAttribute('data-uri');
        const itemToHide = this.element.querySelectorAll('li.super');
        for(let i=0; i<itemToHide.length; i++) {
            itemToHide[i].classList.add('hide');
        }
        elt.classList.remove('hide');
        dataLayer.push({ 'event': 'EventGeneric', 'EventCat': 'Menu', 'EventAction': 'Load', 'EventLibelle': 'Menu Categorie - Niveau 2 - '+uriString });
    }

    closeSub (elt: any, uri: any) {
        const uriString = uri.getAttribute('data-uri');
        const itemToHide = this.element.querySelectorAll('li.super');
        for(let i=0; i<itemToHide.length; i++) {
            itemToHide[i].classList.remove('hide');
        }
        elt.classList.add('hide');
        dataLayer.push({ 'event': 'EventGeneric', 'EventCat': 'Menu', 'EventAction': 'Unload', 'EventLibelle': 'Menu Categorie - Niveau 2 - '+uriString });
    }

    redirect (elt: any) {
        const href = elt.getAttribute('data-href');
        window.open(href);
    }

    buildmodal () {
        const modal = document.createElement('div');
        modal.classList.add('modal-background');
        this.element.parentElement.appendChild(modal);
        this.modal = modal;

        modal.addEventListener('click', (event: MouseEvent) => {
            event.preventDefault();
            event.stopImmediatePropagation();

            this.menu.classList.add('hide');
            const target: any = event.currentTarget;
            target.classList.remove('show');
            this.open = false;
            if(window.innerWidth < 767) {
                this.menumobile.classList.remove('open')
            }
            dataLayer.push({ 'event': 'EventGeneric', 'EventCat': 'Menu', 'EventAction': 'Unload', 'EventLibelle': 'Menu Categorie - Niveau 1' });
        })
    }

    close (event: MouseEvent) {
        event.preventDefault();
        event.stopImmediatePropagation();

        this.menu.classList.add('hide');
        this.open = false;

        if(window.innerWidth < 767) {
            this.menumobile.classList.remove('open')
        } else {
           this.modal.classList.remove('show');
        }
        dataLayer.push({ 'event': 'EventGeneric', 'EventCat': 'Menu', 'EventAction': 'Unload', 'EventLibelle': 'Menu Categorie - Niveau 1' });
    }
}